"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_konva_1 = require("react-konva");
var TimelineEvent_1 = __importDefault(require("./TimelineEvent"));
var dateutil_1 = require("../dateutil");
var data_1 = require("../data");
var data_fr_1 = require("../data_fr");
var konva_1 = __importDefault(require("konva"));
var App_1 = require("../App");
var react_i18next_1 = require("react-i18next");
var isTouchDevice = "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.maxTouchPoints > 0;
var Timeline = function (_a) {
    var onEventSelected = _a.onEventSelected, onEventDeselected = _a.onEventDeselected, selectedEvent = _a.selectedEvent, screenWidth = _a.screenWidth, scrollY = _a.scrollY;
    // Language
    var i18n = (0, react_i18next_1.useTranslation)().i18n;
    var data = data_1.timelineData;
    if (i18n.language.startsWith("fr")) {
        data = data_fr_1.timelineDataFr;
    }
    // Constants
    var marginHeight = 8;
    var legendHeight = 20;
    var timelineStartDate = data_1.timelineData[0].startDate;
    var timelineEndDate = (0, dateutil_1.toTs)("2025-12-01");
    var totalTime = timelineEndDate - timelineStartDate;
    var canvasWidth = screenWidth - App_1.MARGIN_SIDE * 2 - 10;
    var initTimelineWidth = screenWidth > 2500
        ? canvasWidth
        : screenWidth <= 1000
            ? canvasWidth * 2
            : canvasWidth * 1.5;
    //State variables
    var _b = (0, react_1.useState)(initTimelineWidth), timelineWidth = _b[0], setTimelineWidth = _b[1];
    var _c = (0, react_1.useState)(undefined), mouseX = _c[0], setMouseX = _c[1];
    var _d = (0, react_1.useState)(undefined), mouseY = _d[0], setMouseY = _d[1];
    var _e = (0, react_1.useState)(null), mouseDate = _e[0], setMouseDate = _e[1];
    var _f = (0, react_1.useState)(0), scrollX = _f[0], setScrollX = _f[1];
    var _g = (0, react_1.useState)(null), lastTouchDistance = _g[0], setLastTouchDistance = _g[1];
    var _h = (0, react_1.useState)(true), draggable = _h[0], setDraggable = _h[1];
    //Refs of state variables (avoids unnecessary redraws)
    var mouseXRef = (0, react_1.useRef)(undefined);
    var mouseYRef = (0, react_1.useRef)(undefined);
    var timelineMarginTopRef = (0, react_1.useRef)(undefined);
    var timelineWidthRef = (0, react_1.useRef)(timelineWidth);
    var scrollXRef = (0, react_1.useRef)(0);
    var groupRef = (0, react_1.useRef)(null);
    //listening to state variable changes and updating refs
    (0, react_1.useEffect)(function () {
        mouseXRef.current = mouseX;
    }, [mouseX]);
    (0, react_1.useEffect)(function () {
        mouseYRef.current = mouseY;
    }, [mouseY]);
    (0, react_1.useEffect)(function () {
        scrollXRef.current = scrollX;
    }, [scrollX]);
    (0, react_1.useEffect)(function () {
        timelineWidthRef.current = timelineWidth;
    }, [timelineWidth]);
    //listening to configuration changes
    (0, react_1.useEffect)(function () {
        var canvas = document.getElementById("canvas");
        if (canvas) {
            timelineMarginTopRef.current = canvas.getBoundingClientRect().top;
        }
    }, [scrollY, screenWidth]);
    var computeAndSetMouseDate = function (prevX) {
        var mouseTimestamp = timelineStartDate +
            ((prevX + scrollXRef.current) / timelineWidthRef.current) *
                (timelineEndDate - timelineStartDate);
        setMouseDate(mouseTimestamp);
    };
    var isMouseInTimeline = function (mouseY) {
        return mouseY !== undefined &&
            timelineMarginTopRef.current !== undefined &&
            mouseY < timelineMarginTopRef.current + App_1.TIMELINE_HEIGHT &&
            mouseY > timelineMarginTopRef.current;
    };
    //scrolling animation
    var anim = new konva_1["default"].Animation(function (frame) {
        if (selectedEvent)
            return;
        if (mouseXRef.current) {
            if (mouseYRef.current && isMouseInTimeline(mouseYRef.current)) {
                var deltaX_1 = Math.abs(mouseXRef.current - screenWidth / 2);
                if (scrollXRef.current + screenWidth < timelineWidthRef.current &&
                    mouseXRef.current > (screenWidth / 3) * 2) {
                    setScrollX(function (prevX) { return prevX + deltaX_1 / 60; });
                }
                else if (scrollXRef.current > 0 &&
                    mouseXRef.current < screenWidth / 3) {
                    setScrollX(function (prevX) { return prevX - deltaX_1 / 60; });
                }
                computeAndSetMouseDate(mouseXRef.current);
            }
        }
    });
    react_1["default"].useEffect(function () {
        var handleWheel = function (event) {
            if (selectedEvent || !isMouseInTimeline(event.clientY))
                return;
            event.preventDefault();
            setTimelineWidth(function (prevWidth) {
                return prevWidth - event.deltaY < canvasWidth //TODO improve check
                    ? prevWidth
                    : prevWidth - event.deltaY;
            });
            var xOffset = event.clientX;
            var addScrollX = -(event.deltaY / 2) * (xOffset / screenWidth);
            setScrollX(function (prevScrollX) { return prevScrollX + addScrollX; });
        };
        var handleMouseMove = function (event) {
            if (selectedEvent)
                return;
            if (event && event.clientX > 0 && event.clientY > 0) {
                if (event.clientY && isMouseInTimeline(event.clientY)) {
                    setMouseX(event.clientX);
                    setMouseY(event.clientY);
                    computeAndSetMouseDate(event.clientX);
                }
            }
        };
        window.addEventListener("wheel", handleWheel, { passive: false });
        window.addEventListener("mousemove", handleMouseMove);
        anim.start();
        return function () {
            window.removeEventListener("wheel", handleWheel);
            window.removeEventListener("mousemove", handleMouseMove);
            anim.stop();
        };
    }, [selectedEvent, screenWidth]);
    //computing year labels
    var yearLabels = [];
    var timestamp = (0, dateutil_1.nearestJanuary1stTimestamp)(timelineStartDate);
    while (timestamp <= timelineEndDate) {
        var yearOffset = timestamp - timelineStartDate;
        var yearX = (yearOffset / totalTime) * timelineWidth - scrollX;
        yearLabels.push(react_1["default"].createElement(react_konva_1.Text, { key: "year_".concat(timestamp), x: App_1.MARGIN_SIDE + yearX - 4, y: App_1.TIMELINE_HEIGHT - 35, text: "| " + (0, dateutil_1.tsToYearStr)(timestamp), fill: "black", fontFamily: "Trebuchet MS" }));
        timestamp = (0, dateutil_1.nearestJanuary1stTimestamp)(timestamp);
    }
    return (react_1["default"].createElement("div", { id: "timelineWrapper", style: {
            margin: 0,
            padding: 0,
            overflow: "hidden",
            width: canvasWidth,
            height: App_1.TIMELINE_HEIGHT
        } },
        react_1["default"].createElement(react_konva_1.Stage, { id: "canvas", width: canvasWidth, height: App_1.TIMELINE_HEIGHT, onMouseMove: function (e) {
                setMouseX(e.evt.clientX);
                setMouseY(e.evt.clientY);
            } },
            react_1["default"].createElement(react_konva_1.Layer, { key: 0 },
                react_1["default"].createElement(react_konva_1.Group, { ref: groupRef, onClick: function () {
                        if (selectedEvent) {
                            onEventDeselected();
                        }
                    }, onTap: function () {
                        if (selectedEvent) {
                            onEventDeselected();
                        }
                    }, onTouchMove: function (e) {
                        if (e.evt.touches.length === 2) {
                            setDraggable(false);
                            var touch1 = e.evt.touches[0];
                            var touch2 = e.evt.touches[1];
                            var currentDistance = Math.sqrt(Math.pow(touch1.clientX - touch2.clientX, 2) +
                                Math.pow(touch1.clientY - touch2.clientY, 2));
                            var centerX = (touch1.clientX + touch2.clientX) / 2;
                            if (lastTouchDistance) {
                                var distanceChange = currentDistance - lastTouchDistance;
                                var newWidth = timelineWidth + distanceChange * 2;
                                var addScrollX = centerX * (distanceChange * 2 / timelineWidth);
                                if (newWidth > canvasWidth) { //TODO improve check
                                    setTimelineWidth(newWidth);
                                    groupRef.current && groupRef.current.x(groupRef.current.x() - addScrollX * 2);
                                }
                            }
                            else {
                                setDraggable(true);
                            }
                            setLastTouchDistance(currentDistance);
                            e.evt.preventDefault();
                        }
                    }, onTouchEnd: function () { setDraggable(true); setLastTouchDistance(null); }, draggable: draggable, dragBoundFunc: function (pos) {
                        if (!isTouchDevice || (mouseX && mouseX > 0)) {
                            //if not a touch device or mouse has been detected
                            return {
                                x: 0,
                                y: 0
                            };
                        }
                        var x = pos.x;
                        if (x > 0 || x < -timelineWidth + screenWidth) {
                            x = this.absolutePosition().x; //cancel if outside of bounds
                        }
                        if (selectedEvent) {
                            onEventDeselected();
                        }
                        return {
                            x: x,
                            y: 0
                        };
                    } },
                    react_1["default"].createElement(react_konva_1.Rect, { id: "timeline-background", x: App_1.MARGIN_SIDE, y: 0, width: timelineWidth, height: App_1.TIMELINE_HEIGHT, fill: "transparent" }),
                    mouseX && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement(react_konva_1.Rect, { id: "tracking-line", x: mouseX, y: 0, width: 1, height: App_1.TIMELINE_HEIGHT - 5, fill: "#93003a" }),
                        react_1["default"].createElement(react_konva_1.Text, { id: "tracking-text", x: mouseX < screenWidth - 100 ? mouseX + 5 : mouseX - 60, y: App_1.TIMELINE_HEIGHT - 5 - legendHeight / 2, text: (0, dateutil_1.tsToShortStr)(mouseDate || timelineStartDate, i18n.language), fill: "#93003a", fontFamily: "Trebuchet MS" }))),
                    data.map(function (event, index) {
                        var startTimeOffset = event.startDate - timelineStartDate;
                        var endTimeOffset = event.endDate
                            ? event.endDate - timelineStartDate
                            : totalTime;
                        var startX = (startTimeOffset / totalTime) * timelineWidth;
                        var endX = (endTimeOffset / totalTime) * timelineWidth;
                        var eventWidth = endX - startX;
                        var pointedAt = !selectedEvent &&
                            !!mouseX &&
                            mouseX + scrollX > startX &&
                            mouseX + scrollX < endX;
                        return (react_1["default"].createElement(react_konva_1.Group, { key: "group_" + index },
                            react_1["default"].createElement(TimelineEvent_1["default"], { key: index, index: index, x: App_1.MARGIN_SIDE + startX - scrollX, y: 4 + event.line * App_1.LINE_HEIGHT + marginHeight * event.line, eventWidth: eventWidth, pointedAt: pointedAt, event: event, pause: !!selectedEvent, selected: event == selectedEvent, onEventSelected: function (e, x, y) {
                                    if (mouseX && mouseY) {
                                        onEventSelected(e, mouseX, mouseY);
                                    }
                                    else {
                                        onEventSelected(e, 0, timelineMarginTopRef.current ? timelineMarginTopRef.current : y);
                                    }
                                } })));
                    }),
                    react_1["default"].createElement(react_1["default"].Fragment, null, yearLabels))))));
};
exports["default"] = Timeline;
